// extracted by mini-css-extract-plugin
export default {"gauge":"styles_gauge__+XNID"};